module.exports = __webpack_public_path__ + "img/icon-location.c61bed8d.svg";